/**
 * @generated SignedSource<<5a018e607d57d1fd2125659c0856f752>>
 * @relayHash 21d75a0a1f908769c92ef070cccb2c57
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 21d75a0a1f908769c92ef070cccb2c57

import { ConcreteRequest } from 'relay-runtime';
export type De_confirmDuplicatePatientsInput = {
  duplicatePatientIds: ReadonlyArray<string>;
  primaryPatientId: string;
  reason: string;
  undoDuplicatePatientIds: ReadonlyArray<string>;
};
export type deConfirmDuplicatePatientsMutation$variables = {
  input: De_confirmDuplicatePatientsInput;
};
export type deConfirmDuplicatePatientsMutation$data = {
  readonly de_confirmDuplicatePatients: {
    readonly de_Patient: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type deConfirmDuplicatePatientsMutation = {
  response: deConfirmDuplicatePatientsMutation$data;
  variables: deConfirmDuplicatePatientsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "de_Patient",
  "kind": "LinkedField",
  "name": "de_Patient",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deConfirmDuplicatePatientsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_confirmDuplicatePatientsPayload",
        "kind": "LinkedField",
        "name": "de_confirmDuplicatePatients",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deConfirmDuplicatePatientsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_confirmDuplicatePatientsPayload",
        "kind": "LinkedField",
        "name": "de_confirmDuplicatePatients",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "21d75a0a1f908769c92ef070cccb2c57",
    "metadata": {},
    "name": "deConfirmDuplicatePatientsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e0d51c4f8fb8361aba58675fda2c547d";

export default node;
